const HOME_API = {
    getUserInfo: {
        method: 'post',
        url: 'sr_scm/home'
    },
    //菜单列表
    getMenu: {
        method: 'get',
        url: 'sr_scm/menu'
    },
    //角色列表
    getRole: {
        method: 'get',
        url: 'sr_scm/role'
    },
    //全部菜单
    menu: {
        method: 'get',
        url: 'sr_scm/getMenu'
    },
    //角色创建
    createRole: {
        method: 'post',
        url: 'sr_scm/createRole'
    },
    //获取编辑角色角色信息
    getEditRole: {
        method: 'get',
        url: 'sr_scm/getEditRole'
    },
    //修改角色
    editRole: {
        method: 'post',
        url: 'sr_scm/editRole'
    },
    //删除角色
    deleteRole: {
        method: 'post',
        url: 'sr_scm/deleteRole'
    },
    //用户列表
    getSupplierUser: {
        method: 'get',
        url: 'sr_scm/getSupplierUser'
    },
    //创建子用户
    createSupplierUser: {
        method: 'post',
        url: 'sr_scm/createSupplierUser'
    },
    //获取编辑子用户用户信息
    getEditUser: {
        method: 'get',
        url: 'sr_scm/getEditUser'
    },
    //修改子用户
    editUser: {
        method: 'post',
        url: 'sr_scm/editUser'
    },
    //注销子用户
    deleteUser: {
        method: 'post',
        url: 'sr_scm/deleteUser'
    },
    //重置密码
    resetPassword: {
        method: 'post',
        url: 'sr_scm/resetPassword'
    },
    //修改密码
    updatePassword: {
        method: 'post',
        url: 'sr_scm/updatePassword'
    },
    //查询订单
    getOrder: {
        method: 'get',
        url: 'sr_scm/getOrder'
    },
    //获取订单明细
    getOrderDetail: {
        method: 'post',
        url: 'sr_scm/getOrderDetail'
    },
    //修改发货数量
    updateIssue: {
        method: 'post',
        url: 'sr_scm/updateIssue'
    },
    //确认订单操作
    orderConfirm: {
        method: 'post',
        url: 'sr_scm/orderConfirm'
    },
    //保存发货信息
    saveShipmentInfo: {
        method: 'post',
        url: 'sr_scm/saveShipmentInfo'
    },
    //获取差价单列表
    getDifferencesList: {
        method: 'get',
        url: 'sr_scm/getDifferencesList'
    },
    //获取差价单明细
    getDifferenceDetail: {
        method: 'get',
        url: 'sr_scm/getDifferenceDetail'
    },
    //差价单确认
    differenceConfirm: {
        method: 'post',
        url: 'sr_scm/differenceConfirm'  
    },
    //获取退货单列表
    getProList: {
        method: 'get',
        url: 'sr_scm/getProList'
    },
    //获取退货单明细
    getProDetail: {
        method: 'get',
        url: 'sr_scm/getProDetail'
    },
    //退货单确认
    proConfirm: {
        method: 'post',
        url: 'sr_scm/proConfirm'  
    },
    //修改退货差异备注
    updateSupplier_remarks: {
        method: 'post',
        url: 'sr_scm/updateSupplier_remarks'  
    },
    //获取对账单列表
    getFinance: {
        method: 'get',
        url: 'sr_scm/getFinance'
    },
    //获取对账单明细
    getSpaDetail: {
        method: 'get',
        url: 'sr_scm/getSpaDetail'
    },
    //对账单确认
    spaConfirm: {
        method: 'post',
        url: 'sr_scm/spaConfirm'  
    }
}

export default HOME_API